import { useContext } from "react";

import { TenantContext } from "../../../../../templates/context/TenantContext.jsx";

import { Progress } from "@aidron/aidron-ds";

import { textFormatter } from "../../../../../utils/formatter/formatter.js";
import { formatAdjustPlanIndex } from "../../../../../utils/utils.js";

import { i18n } from "../../../../../translate/i18n.js";

import {
  OuterContainer, 
  CardsContainer, 
  Box, 
  SumLine,
  Line,
  HSumBoxOuterContainer
} from "./MainIndexes.style.js";

import {
  CustomCard,
  CustomText,
  CustomHeading
} from "../../../../../components/StyledComponents/styleComponents.index.jsx";

import { MultiSlideCarousel, SumCard } from "../../../../../components/SharedComponents/sharedComponents.index.jsx";

import PropTypes from "prop-types";

const { t } = i18n;

function HierarchySumBox({ ctx, uiState }) {

  const { unit } = useContext(TenantContext);
  const { group } = ctx || {};
  const { boxCount } = uiState ||{};
  
  return (
    <CustomCard padding="10px" width={boxCount < 3 ? "300px" : "225px"} margin="0px 15px">
      <HSumBoxOuterContainer>
        <CustomText allCaps color="mediumGrey" weight="bold" textAlign="center" fontSize={['0.4rem', '0.8rem', '1.1rem']} margin="0">
          {group.name}
        </CustomText>

        <SumLine>
          <CustomText fontSize={['0.4rem', '0.6rem', '1.1rem']}  color="mediumGrey" weight="bold">
            {textFormatter(t("current"), { textTransform: 'uppercase' })}
          </CustomText>

          <CustomText fontSize={['0.4rem', '0.7rem', '1.1rem']}  color="mediumGrey" weight="bold" size="16px">
            {formatAdjustPlanIndex(group.clientPrediction, unit)}
          </CustomText>
        </SumLine>

        <SumLine>
          <CustomText fontSize={['0.4rem', '0.6rem', '1.1rem']}  color="mediumGrey" weight="bold">
            {textFormatter(t("new"), { textTransform: 'uppercase' })}
          </CustomText>
          <CustomText fontSize={['0.4rem', '0.7rem', '1.1rem']}  color="orange" weight="bold" size="16px">
            {formatAdjustPlanIndex(group.aidronPrediction, unit)}
          </CustomText>
        </SumLine>

        <Line />

        <SumLine>
          <CustomText fontSize={['0.4rem', '0.6rem', '1.1rem']}  color="mediumGrey" weight="bold">
            {textFormatter(t("difference"), { textTransform: 'uppercase' })}
          </CustomText>
          
          <CustomText color={group.difference > 0 ? "red" : "blue"} weight="bold" fontSize={['0.4rem', '0.7rem', '1.1rem']} >
            {`${group.difference > 0 ? "-" : "+"} ${formatAdjustPlanIndex(Math.abs(group.difference))}`}
          </CustomText>
        </SumLine>
      </HSumBoxOuterContainer>
    </CustomCard>
  );
};

export function MainIndexes({ ctx, uiState }) {

  const { totalSummary, groupsWithIndexes } = ctx || {};
  const { selected } = uiState || {};

  const levelGroups = groupsWithIndexes || [];

   const orderByDifference = () => {
    return [...levelGroups].sort((a, b) => 
      Math.abs(b.difference) - Math.abs(a.difference)
    );
  };

  if (!selected) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Progress circular />
      </div>
    );
  };

  return (
    <OuterContainer>
      <CardsContainer>
          
        <SumCard 
          ctx={{ number: totalSummary?.clientPrediction, label: t("currentPlan") }}
          uiState={{ icon: "file-text", numberColor: "mediumGrey" }}/>

        <SumCard 
          ctx={{ number: totalSummary?.aidronPrediction, label: t("newPlan") }}
          uiState={{ icon: "target", numberColor: "orange" }}/>

        <SumCard 
          ctx={{ number: totalSummary?.difference, label: t("differenceFromPlan"), prefix: totalSummary?.difference > 0 ? "-" : "+" }}
          uiState={{ icon: "dollar-sign", numberColor: "mediumGrey" }}/>
      </CardsContainer>

      <CustomCard border="none">
        <CustomHeading fontSize={['0.5rem', '1rem', '1.3rem']} color="mediumGrey" textAlign="center">
          {t("total")} {selected?.groupDisplayName || t("company")}
        </CustomHeading>

        <MultiSlideCarousel
          slideCount={levelGroups.length}
          key={levelGroups.length}>
          {orderByDifference().map((group, index) => (
            <Box key={`group-${index}-${group.name}`}>
              <HierarchySumBox ctx={{ group: group }} uiState={{ boxCount: levelGroups.length }} />
            </Box>
          ))}
        </MultiSlideCarousel>
      </CustomCard>
    </OuterContainer>
  );
};

HierarchySumBox.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
};

MainIndexes.propTypes = {
  actions: PropTypes.shape(),
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
};